export default "__VITE_ASSET__zf$rtOkF__"